import React from 'react'
import { SuperGrain } from '../SuperGrain'

export const BlueOrangeSphereLeftTop = ({
  hideGrain,
  svgProps,
}: {
  hideGrain?: boolean
  svgProps: React.SVGProps<SVGSVGElement>
}) => {
  return (
    <svg
      {...svgProps}
      viewBox="0 0 717 721"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4716_2115)">
        <g filter="url(#filter0_f_4716_2115)">
          <circle
            cx="878.618"
            cy="878.618"
            r="878.618"
            transform="matrix(-1.8677e-07 -0.999999 -1 1.47275e-06 506.265 765.429)"
            fill="url(#paint0_radial_4716_2115)"
            fillOpacity="0.7"
          />
        </g>
        <g filter="url(#filter1_f_4716_2115)">
          <circle
            cx="853.832"
            cy="853.832"
            r="853.832"
            transform="matrix(-1.8677e-07 -0.999999 -1 1.47275e-06 481.479 740.643)"
            fill="url(#paint1_radial_4716_2115)"
          />
        </g>
        <g filter="url(#filter2_f_4716_2115)">
          <circle
            cx="779.47"
            cy="779.47"
            r="779.47"
            transform="matrix(-1.8677e-07 -0.999999 -1 1.47275e-06 407.117 666.281)"
            fill="url(#paint2_radial_4716_2115)"
          />
        </g>
        <g filter="url(#filter3_f_4716_2115)">
          <circle
            cx="508.212"
            cy="508.212"
            r="508.212"
            transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 137.604 395.022)"
            fill="#176AE5"
          />
        </g>
        <g filter="url(#filter4_f_4716_2115)">
          <circle
            cx="300.112"
            cy="300.112"
            r="300.112"
            transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 -75.3877 186.922)"
            fill="#81D3FF"
          />
        </g>
        <g filter="url(#filter5_f_4716_2115)">
          <circle
            cx="761.834"
            cy="761.834"
            r="761.221"
            transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 391.226 648.645)"
            stroke="#F9EFE4"
            strokeWidth="1.22417"
          />
        </g>
        <g
          filter="url(#filter6_f_4716_2115)"
          data-figma-bg-blur-radius="6.17337"
        >
          <path
            d="M234.993 -1590.91L35.8205 -847.588L-163.351 -104.268L-828.106 -282.388L-429.761 -1769.03L234.993 -1590.91Z"
            fill="url(#paint3_linear_4716_2115)"
            fillOpacity="0.01"
          />
        </g>
        <g filter="url(#filter7_f_4716_2115)">
          <circle
            cx="31.9184"
            cy="31.9184"
            r="31.9184"
            transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 385.948 155.489)"
            fill="white"
          />
        </g>
        <g filter="url(#filter8_f_4716_2115)">
          <circle
            cx="27.3829"
            cy="27.3829"
            r="27.3829"
            transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 381.412 150.953)"
            fill="#3F94EC"
          />
        </g>
        <g filter="url(#filter9_f_4716_2115)">
          <circle
            cx="12.8076"
            cy="12.8076"
            r="12.8076"
            transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 355.193 170.299)"
            fill="url(#paint4_radial_4716_2115)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_4716_2115"
          x="-1279.93"
          y="-1020.76"
          width="1815.14"
          height="1815.14"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="14.477"
            result="effect1_foregroundBlur_4716_2115"
          />
        </filter>
        <filter
          id="filter1_f_4716_2115"
          x="-1262.92"
          y="-1003.75"
          width="1781.12"
          height="1781.12"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="18.364"
            result="effect1_foregroundBlur_4716_2115"
          />
        </filter>
        <filter
          id="filter2_f_4716_2115"
          x="-1231.74"
          y="-972.575"
          width="1718.78"
          height="1718.77"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="39.9586"
            result="effect1_foregroundBlur_4716_2115"
          />
        </filter>
        <filter
          id="filter3_f_4716_2115"
          x="-1005.08"
          y="-747.666"
          width="1268.95"
          height="1268.95"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="63.132"
            result="effect1_foregroundBlur_4716_2115"
          />
        </filter>
        <filter
          id="filter4_f_4716_2115"
          x="-991.272"
          y="-728.963"
          width="1231.54"
          height="1231.54"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="157.83"
            result="effect1_foregroundBlur_4716_2115"
          />
        </filter>
        <filter
          id="filter5_f_4716_2115"
          x="-1135.11"
          y="-877.692"
          width="1529.01"
          height="1529.01"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.33454"
            result="effect1_foregroundBlur_4716_2115"
          />
        </filter>
        <filter
          id="filter6_f_4716_2115"
          x="-990.48"
          y="-1931.4"
          width="1387.85"
          height="1989.51"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="81.187"
            result="effect1_foregroundBlur_4716_2115"
          />
        </filter>
        <clipPath
          id="bgblur_1_4716_2115_clip_path"
          transform="translate(990.48 1931.4)"
        >
          <path d="M234.993 -1590.91L35.8205 -847.588L-163.351 -104.268L-828.106 -282.388L-429.761 -1769.03L234.993 -1590.91Z" />
        </clipPath>
        <filter
          id="filter7_f_4716_2115"
          x="319.603"
          y="89.1436"
          width="68.8546"
          height="68.8546"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.25447"
            result="effect1_foregroundBlur_4716_2115"
          />
        </filter>
        <filter
          id="filter8_f_4716_2115"
          x="316.462"
          y="86.0031"
          width="75.1343"
          height="75.1343"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5.09212"
            result="effect1_foregroundBlur_4716_2115"
          />
        </filter>
        <filter
          id="filter9_f_4716_2115"
          x="325.623"
          y="140.729"
          width="33.5247"
          height="33.5247"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.97735"
            result="effect1_foregroundBlur_4716_2115"
          />
        </filter>
        <radialGradient
          id="paint0_radial_4716_2115"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(878.616 506.284) rotate(89.9999) scale(1698.37)"
        >
          <stop offset="0.305" stopColor="#FF7439" />
          <stop offset="0.629788" stopColor="#EEBACB" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4716_2115"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(853.831 492.002) rotate(89.9999) scale(1650.46)"
        >
          <stop offset="0.2" stopColor="#EEBACB" />
          <stop offset="0.365" stopColor="#83D4FF" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4716_2115"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(779.469 449.153) rotate(89.9999) scale(1506.72)"
        >
          <stop offset="0.305" stopColor="#ECB9CB" />
          <stop offset="0.629788" stopColor="#EEBACB" />
          <stop offset="0.744002" stopColor="white" />
        </radialGradient>
        <linearGradient
          id="paint3_linear_4716_2115"
          x1="585.978"
          y1="-519.381"
          x2="229.035"
          y2="-615.023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
        <radialGradient
          id="paint4_radial_4716_2115"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.8076 12.8076) rotate(-90) scale(12.8076)"
        >
          <stop stopColor="white" />
        </radialGradient>
      </defs>
      {!hideGrain && (
        <foreignObject x="0" y="0" width="100%" height="100%">
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
